import React from "react";
import { useT } from "@/i18n/I18nContext";

export default function PageHeader({ title, subtitle, actions, testId }) {
  const t = useT();
  return (
    <div data-testid={testId || "page-header"} className="flex items-start justify-between mb-6 gap-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-[#1F2937]">{typeof title === "string" ? t(title) : title}</h1>
        {subtitle && (
          <p className="mt-1 text-sm text-[#6B7280]">{typeof subtitle === "string" ? t(subtitle) : subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  );
}
